import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ProdutoEspecialCliente } from '../../core/models/produtos/produto-especial-cliente';

@Component({
    selector: 'app-tabela-clientes-editavel',
    templateUrl: './tabela-clientes-editavel.component.html',
    styleUrls: ['./tabela-clientes-editavel.component.css'],
    standalone: false
})
export class TabelaClientesEditavelComponent implements OnInit {
  @Input() clientes: ProdutoEspecialCliente[] = [];
  @Output() clientesRemovidos = new EventEmitter<ProdutoEspecialCliente[]>();

  /* Edição Inline */
  editandoCelula: { index: number; campo: string } = null;
  valorOriginal: any = null;

  /* Edição em Massa */
  clientesSelecionados: Set<number> = new Set();
  todosSelecionados: boolean = false;

  edicaoEmMassa = {
  };

  /* Console para Debug */
  console = console;

  constructor(private toastr: ToastrService) { }

  ngOnInit(): void {
  }

  /* ===== EDIÇÃO INLINE ===== */

  iniciarEdicao(index: number, campo: string) {
    this.editandoCelula = { index, campo };
    this.valorOriginal = this.clientes[index][campo];
  }

  finalizarEdicao(index: number, campo: string) {
    if (this.editandoCelula && this.editandoCelula.index === index && this.editandoCelula.campo === campo) {
      this.toastr.success("Alteração salva!", "Sucesso");
      this.editandoCelula = null;
      this.valorOriginal = null;
    }
  }

  cancelarEdicao(index: number) {
    if (this.editandoCelula && this.editandoCelula.index === index) {
      this.clientes[index][this.editandoCelula.campo] = this.valorOriginal;
      this.editandoCelula = null;
      this.valorOriginal = null;
    }
  }

  estaEditando(index: number, campo: string): boolean {
    return this.editandoCelula != null && this.editandoCelula.index === index && this.editandoCelula.campo === campo;
  }

  /* ===== EDIÇÃO EM MASSA ===== */

  selecionarCliente(idClienteSelecionado: number) {
    if (this.clientesSelecionados.has(idClienteSelecionado)) {
      this.clientesSelecionados.delete(idClienteSelecionado);
    } else {
      this.clientesSelecionados.add(idClienteSelecionado);
    }
    this.atualizarCheckboxTodosSelecionados();
  }

  estaClienteSelecionado(idClienteSelecionado: number): boolean {
    return this.clientesSelecionados.has(idClienteSelecionado);
  }

  selecionarTodos() {
    if (this.todosSelecionados) {
      this.clientesSelecionados.clear();
      this.todosSelecionados = false;
    } else {
      this.clientesSelecionados.clear();
      for (let cliente of this.clientes) {
        this.clientesSelecionados.add(cliente.idcliente);
      }
      this.todosSelecionados = true;
    }
  }

  atualizarCheckboxTodosSelecionados() {
    this.todosSelecionados = this.clientesSelecionados.size === this.clientes.length && this.clientes.length > 0;
  }

  aplicarEdicaoEmMassa() {
    if (this.clientesSelecionados.size === 0) {
      this.toastr.info("Selecione pelo menos um cliente!", "Informação");
      return;
    }

    this.toastr.success(`${this.clientesSelecionados.size} cliente(s) selecionado(s)!`, "Sucesso");
    this.limparEdicaoEmMassa();
  }

  limparEdicaoEmMassa() {
    this.edicaoEmMassa = {
    };
    this.clientesSelecionados.clear();
    this.todosSelecionados = false;
  }

  removerClienteEmMassa() {
    if (this.clientesSelecionados.size === 0) {
      this.toastr.info("Selecione pelo menos um cliente!", "Informação");
      return;
    }

    const removidos = this.clientes.filter(cliente =>
      this.clientesSelecionados.has(cliente.idcliente)
    );

    this.clientesSelecionados.clear();
    this.todosSelecionados = false;

    // Quem mantém a lista é o componente pai: ele remove da tela e persiste a exclusão ao salvar
    this.clientesRemovidos.emit(removidos);

    this.toastr.success(`${removidos.length} cliente(s) removido(s)!`, "Sucesso");
  }
}
